import { Options } from 'highcharts';
import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';
import { formatters } from '@utils/formattersV2';

export const buyerChartOptions = ({
  existingBuyerPercentage,
  newBuyerPercentage,
}: {
  existingBuyerPercentage: number;
  newBuyerPercentage: number;
}): Options => ({
  chart: {
    type: 'column',
    height: 400,
    spacingTop: 10,
    spacingBottom: 10,
    backgroundColor: 'transparent',
  },
  title: {
    text: 'Percent New Buyer vs. Existing buyer',
    style: {
      fontSize: '16px',
      fontWeight: '600',
      color: unifiedPlatformColorPalette.black,
    },
  },
  xAxis: {
    categories: ['Existing Buyers', 'New Buyers'],
    labels: { style: { fontSize: '13px' } },
    lineColor: unifiedPlatformColorPalette.lightGrey300,
  },
  yAxis: {
    min: 0,
    max: 100,
    tickInterval: 20,
    title: { text: '' },
    labels: {
      formatter() {
        return formatters.percentage((this.value as number) / 100);
      },
      style: { fontSize: '12px' },
    },
    gridLineColor: unifiedPlatformColorPalette.lightGrey300,
  },
  legend: { enabled: false },
  tooltip: { enabled: false },
  plotOptions: {
    column: {
      pointWidth: 40,
      borderRadius: 5,
      groupPadding: 0,
      pointPadding: 0,
      dataLabels: {
        enabled: true,
        formatter() {
          return formatters.percentage(this.y! / 100, { decimals: 1 });
        },
        style: {
          fontSize: '13px',
          fontWeight: 'bold',
          color: unifiedPlatformColorPalette.black,
          textOutline: 'none',
        },
      },
    },
  },
  series: [
    {
      name: '% Buyers',
      type: 'column',
      data: [
        {
          y: existingBuyerPercentage,
          color: unifiedPlatformColorPalette.chartLightGreen,
        },
        {
          y: newBuyerPercentage,
          color: unifiedPlatformColorPalette.chartDarkGreen,
        },
      ],
      colorByPoint: false,
    },
  ],
  credits: { enabled: false },
  exporting: { enabled: false },
});
